import { createEntityAdapter } from '@reduxjs/toolkit';

import type { CartRecipe } from '../structureDefinitions/cartState';

export const recipesAdapter = createEntityAdapter<CartRecipe, string>({
    selectId: (recipe) => recipe.code,
});
